/**
 * Tap-to-select list used across the request wizards (service category,
 * urgency, property type). One option per row, big touch targets, immediate
 * selection. Shared by the authenticated NewRfq wizard and the anonymous intake
 * funnel so the two never drift apart.
 */
export function ChoiceList({
  heading,
  options,
  selected,
  onSelect,
}: {
  heading: string;
  options: { value: string; label: string }[];
  selected: string;
  onSelect: (value: string) => void;
}) {
  return (
    <div className="space-y-3">
      <h2 className="text-base font-semibold">{heading}</h2>
      <ul className="space-y-2">
        {options.map((opt) => (
          <li key={opt.value}>
            <button
              type="button"
              onClick={() => onSelect(opt.value)}
              className={`block w-full rounded-lg border p-4 text-left text-sm active:bg-slate-50 ${
                selected === opt.value ? "border-teal-700 bg-teal-50" : "border-slate-200 bg-white"
              }`}
            >
              {opt.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
